export default __webpack_public_path__ + "static/media/Big_Gaming.fc78b431.png";